import { inject } from '@angular/core';
import { CanActivateFn, createUrlTreeFromSnapshot } from '@angular/router';
import { FeatureFlagEnum } from '@models/enums/feature-flag.enum';
import { FeatureFlagService } from '@services/feature-flag/feature-flag.service';

export const featureActiveGuard: CanActivateFn = (route, _state) => {
  const featureFlagService = inject(FeatureFlagService);
  const featureFlag = route.data['featureFlag'] as FeatureFlagEnum | undefined;

  if (featureFlag) {
    if (featureFlagService.isFeatureActive(featureFlag)) {
      return true;
    } else if (route.data['redirectIfInactive']) {
      return createUrlTreeFromSnapshot(route, [
        route.data['redirectIfInactive'],
      ]);
    }
    console.warn(`Feature flag '${featureFlag}' is not active.`);
    return createUrlTreeFromSnapshot(route, ['/not-found']);
  }

  console.warn(`No feature flag provided for route: '${_state.url}'`);
  return createUrlTreeFromSnapshot(route, ['/not-found']);
};
